import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmailCustomizationService } from 'src/app/shared/services/email-customization.service';
import { EmailScenario } from '../models/emailCustomization';

@Injectable()
export class EmailCustomizationResolver {
  constructor(private emailCustomizationService: EmailCustomizationService) {}

  resolve(route: ActivatedRouteSnapshot) {
    let teamId = route.params.id ? route.params.id : route.parent.params.id;
    if (!teamId && route.parent?.parent) {
      teamId = route.parent.parent.params.teamId;
    }
    const scenario = route.paramMap.get('scenario') as EmailScenario;
    return this.emailCustomizationService.getTeamEmailCustomization(teamId, scenario);
  }
}
